/* START GENAI@GHCOPILOT */

export function generateCodeVerifier(): string {
  // Generate a 32-byte (256-bit) random sequence
  const randomBytes = crypto.getRandomValues(new Uint8Array(32));
  // Convert the random bytes to a base64url-encoded string
  const base64url = btoa(String.fromCharCode(...randomBytes))
    .replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove trailing '='

  return base64url;
}

export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  const base64String = btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

  return base64String;
}
/* END GENAI@GHCOPILOT */
